import React, { Component } from "react"
import { Row, Col, Table } from "react-bootstrap"
import moment from 'moment';
import { PropTypes } from "prop-types"
import { propTypes } from 'redux-form'
import { videoblue, red, warning, green } from '../../../utils/constants'

const EventStatusDesc = {
  InCompleteSetup: 'Setup not completed',
  ComingUp: 'Coming up',
  PendingPost: 'Pending Post Event Report',
  Completed: 'Completed'
}

class SearchResults extends Component {

  static propTypes = {
    ...propTypes
  }
  constructor(props) {
    super(props)
    this.setStatusColor = this.setStatusColor.bind(this)
  }
  //#region Supporting functions
  //#endregion
  setStatusColor(status) {
    switch (status) {
      case EventStatusDesc.InCompleteSetup:
        {
          return warning
        }
      case EventStatusDesc.ComingUp:
        {
          return videoblue
        }
      case EventStatusDesc.PendingPost:
        {
          return red
        }
      case EventStatusDesc.Completed:
        {
          return green
        }
    }
  }
  render() {
    const {
      searchResults
    } = this.props;

    const recordsFound = (searchResults !== undefined) && (searchResults.length > 0)

    if (recordsFound === false) {
      return (<span style={{ color: warning }}>
        <i className='fa fa-info-circle' />&nbsp;&nbsp;No events found
						</span>)
    }

    return (
      //<ContentWrapper> 
      <Row>
        <Col xs={12}>
          <Table striped>
            <thead>
              <tr>
                <th>Event Name</th>
                <th>Center</th>
                <th>City</th>
                <th>State</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Status</th>
                <th>Director</th>
                <th>Phone Number</th>
                <th>Event Email</th>
              </tr>
            </thead>
            <tbody>
              {
                searchResults && searchResults.map((item, key) => (
                  <tr key={key}>
                    <td>{item.tournamentname}</td>
                    <td>{item.center}</td>
                    <td>{item.city}</td>
                    <td>{item.state}</td>
                    <td>{moment(item.startdate).format('MM/DD/YYYY')}</td>
                    <td>{moment(item.enddate).format('MM/DD/YYYY')}</td>
                    <td>{item.status}</td>
                    <td>{item.tournamentdirector}</td>
                    <td>{item.phonenumber}</td>
                    <td>{item.eventEmail !== null ? item.eventEmail :  item.directorssoemail}</td>
                  </tr>))
              }
            </tbody>
          </Table>
        </Col>
      </Row>
/* 	</ContentWrapper>*/)
  }
}
SearchResults.propTypes = {
  searchResults: PropTypes.array,
};
export default SearchResults;



// WEBPACK FOOTER //
// ./src/containers/eventsview/components/searchresults.js